<template>
  <div class="dashboard">
    <div class="header-bar">
      <div class="header-info">
        <h2>资源管理</h2>
        <p>{{ list.length }} 个资源</p>
      </div>
      <div class="header-actions">
        <span class="header-link" @click="$router.push('/resources/removed')">已下架</span>
        <van-icon name="add-o" size="22" class="header-add" @click="$router.push('/resources/new')" />
      </div>
    </div>

    <van-notice-bar
      v-if="!isApproved"
      text="您的账号正在审核中，审核通过后可发布资源"
      left-icon="info-o"
      color="#f59e0b"
      background="#fef3c7"
    />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list-wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 没有更多了 —"
        @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.id" :disabled="!isApproved">
          <div class="resource-card" @click="goEdit(item)">
            <div class="card-cover">
              <img v-if="item.coverUrl" :src="item.coverUrl" alt="" />
              <div v-else class="cover-placeholder">
                <van-icon name="photo-o" size="32" color="#cbd5e1" />
              </div>
              <div class="cover-badge" :class="item.isPaid ? 'is-paid' : 'is-free'">
                {{ item.isPaid ? '¥' + item.price : '免费' }}
              </div>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc" v-if="item.description">{{ item.description }}</div>
              <div class="card-footer">
                <van-tag
                  :type="item.status === 'published' ? 'success' : 'default'"
                  size="small" plain
                >
                  {{ item.status === 'published' ? '已上架' : '已下架' }}
                </van-tag>
                <span class="card-date">{{ formatDate(item.createdAt) }}</span>
              </div>
            </div>
          </div>
          <template #right>
            <van-button square color="#f43f5e" text="下架" @click="onRemove(item)" class="delete-btn" />
          </template>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>

    <van-empty
      v-if="!loading && list.length === 0"
      image="search"
      description="暂无资源，点击右下角发布"
    />

    <div class="fab-btn" @click="$router.push('/resources/new')">
      <van-icon name="add" size="28" color="#fff" />
    </div>
  </div>
</template>

<script>
import { resourceApi, bloggerApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 10, loading: false, finished: false,
      refreshing: false, isApproved: true
    };
  },
  created() { this.fetchProfile(); },
  methods: {
    async fetchProfile() {
      try {
        const res = await bloggerApi.getProfile();
        this.isApproved = res.data.isApproved;
      } catch (e) { /* ignore */ }
    },
    goEdit(item) {
      this.$router.push('/resources/' + item.id + '/edit');
    },
    async onLoad() {
      const user = this.$store.state.user;
      const res = await resourceApi.listByBlogger(user.id, { page: this.page, size: this.size });
      const data = res.data;
      this.list = this.page === 1 ? data.list : [...this.list, ...data.list];
      this.loading = false;
      if (this.list.length >= data.total) this.finished = true;
      this.page++;
    },
    async onRefresh() {
      this.page = 1; this.finished = false; this.list = [];
      this.loading = true; // 设为 true，防止 van-list 检测到列表为空时再次自动触发 onLoad
      await this.onLoad();
      this.refreshing = false;
    },
    async onRemove(item) {
      try {
        await this.$dialog.confirm({ title: '确认下架', message: '确定要下架该资源吗？' });
        await resourceApi.remove(item.id);
        this.$toast.success('已下架');
        this.onRefresh();
      } catch (e) { /* canceled */ }
    },
    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.dashboard {
  min-height: 100vh;
}
.header-bar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
}
.header-bar h2 {
  margin: 0; font-size: 22px; font-weight: 700;
}
.header-bar p {
  margin: 2px 0 0; font-size: 13px; opacity: 0.8;
}
.header-actions {
  display: flex; align-items: center; gap: 14px;
}
.header-link {
  font-size: 14px; font-weight: 500;
  background: rgba(255,255,255,0.2); padding: 6px 12px;
  border-radius: 14px;
}
.header-add {
  background: rgba(255,255,255,0.2);
  border-radius: 50%; padding: 10px;
}
.list-wrap { padding-bottom: 80px; }
.resource-card {
  display: flex; margin: 12px 16px;
  background: #fff; border-radius: 12px;
  overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.card-cover {
  width: 100px; height: 100px; flex-shrink: 0; position: relative;
  background: #f1f5f9;
}
.card-cover img {
  width: 100%; height: 100%; object-fit: cover;
}
.cover-placeholder {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
}
.cover-badge {
  position: absolute; top: 6px; left: 6px;
  padding: 2px 8px; border-radius: 10px;
  font-size: 12px; font-weight: 600; color: #fff;
}
.cover-badge.is-paid { background: rgba(239,68,68,0.9); }
.cover-badge.is-free { background: rgba(34,197,94,0.9); }
.card-body {
  flex: 1; padding: 10px 12px; display: flex;
  flex-direction: column; justify-content: space-between;
  min-width: 0;
}
.card-title {
  font-size: 15px; font-weight: 600; color: #1f2937;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.card-desc {
  font-size: 12px; color: #9ca3af;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  margin-top: 4px;
}
.card-footer {
  display: flex; align-items: center; justify-content: space-between;
}
.card-date {
  font-size: 11px; color: #d1d5db;
}
.fab-btn {
  position: fixed; right: 24px; bottom: 80px;
  width: 56px; height: 56px; border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 16px rgba(99,102,241,0.4);
  z-index: 50;
}
.delete-btn {
  height: 100%;
}
</style>
